/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightCancellationConfirmRequest
 */
export interface FlightCancellationConfirmRequest {
  /**
   *
   * @type {string}
   * @memberof FlightCancellationConfirmRequest
   */
  cancellationRequestId: string;
  /**
   *
   * @type {string}
   * @memberof FlightCancellationConfirmRequest
   */
  expectedRefundAmount: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightCancellationConfirmRequest
   */
  currency: string;
  /**
   *
   * @type {boolean}
   * @memberof FlightCancellationConfirmRequest
   */
  confirmed: boolean;
}

/**
 * Check if a given object implements the FlightCancellationConfirmRequest interface.
 */
export function instanceOfFlightCancellationConfirmRequest(
  value: object
): value is FlightCancellationConfirmRequest {
  if (
    !("cancellationRequestId" in value) ||
    value["cancellationRequestId"] === undefined
  )
    return false;
  if (
    !("expectedRefundAmount" in value) ||
    value["expectedRefundAmount"] === undefined
  )
    return false;
  if (!("currency" in value) || value["currency"] === undefined) return false;
  if (!("confirmed" in value) || value["confirmed"] === undefined) return false;
  return true;
}

export function FlightCancellationConfirmRequestFromJSON(
  json: any
): FlightCancellationConfirmRequest {
  return FlightCancellationConfirmRequestFromJSONTyped(json, false);
}

export function FlightCancellationConfirmRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightCancellationConfirmRequest {
  if (json == null) {
    return json;
  }
  return {
    cancellationRequestId: json["cancellation_request_id"],
    expectedRefundAmount: json["expected_refund_amount"],
    currency: json["currency"],
    confirmed: json["confirmed"],
  };
}

export function FlightCancellationConfirmRequestToJSON(
  json: any
): FlightCancellationConfirmRequest {
  return FlightCancellationConfirmRequestToJSONTyped(json, false);
}

export function FlightCancellationConfirmRequestToJSONTyped(
  value?: FlightCancellationConfirmRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    cancellation_request_id: value["cancellationRequestId"],
    expected_refund_amount: value["expectedRefundAmount"],
    currency: value["currency"],
    confirmed: value["confirmed"],
  };
}
